module.exports = __webpack_public_path__ + "img/dobby_loader.7131de0b.svg";